module.exports = "/images/vehicle-registration.svg?58ffc88b53d1a436a047502c5cbaf376";